import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {API_URL, MagazineFormData, PackageFormData} from './base/interfaces';
import {AuthService} from './auth.service';
import { AngularFirestore, CollectionReference, Query } from '@angular/fire/firestore';
import { Package } from './shared/intefaces/package';
import { ThrowStmt } from '@angular/compiler';

@Injectable({
  providedIn: 'root'
})
export class PackageService {
  url = `${API_URL}package`;

  constructor(private http: HttpClient, private auth: AuthService, private firestore: AngularFirestore) { }

  get options(): any {
    return {
      'headers': {
        // 'Authorization': `Bearer${this.auth.token}`
      }
    };
  }

  public list(entry: any, status: boolean, sort: string, direction: string) {
    return this.firestore.collection<Package>('packages', ref => {
      let query: CollectionReference | Query = ref;

      query = query.where('published', '==', status)
        .orderBy(sort, 'desc');

      if (entry) {
        if (direction === 'before') {
          query = query.endBefore(entry).limitToLast(20);
        } else {
          query = query.startAfter(entry).limit(20);
        }
      } else {
        query = query.limit(20);
      }

      return query;
    }).get();
  }

  public listActive() {
    return this.firestore.collection<Package>('packages', ref => ref.where('published', '==', true).orderBy('title')).get();
  }

  public getPackage(id: string) {
    return this.firestore.collection('packages').doc(id).get();
  }

  public create(id: string, data: any) {
    return this.firestore.collection('packages').doc(id).set(data);
  }

  public update(id:string, data: any) {
    return this.firestore.collection('packages').doc(id).update(data);
  }

  public delete(id: string) {
    return this.firestore.collection('packages').doc(id).delete();
  }

  public togglePublish(id: string, published: boolean) {
    const data = {
      published: !published
    }

    return this.firestore.collection('packages').doc(id).update(data);
  }
}
